export default function formatBrazilianPhone(phoneNumber) {
  if (!phoneNumber) {
    return;
  }

  const areaCode = phoneNumber.slice(2, 4);
  const firstPart = phoneNumber.slice(4, 9);
  const secondPart = phoneNumber.slice(9, 13);

  return `(${areaCode}) ${firstPart}-${secondPart}`;
}